import { createAsyncThunk } from "@reduxjs/toolkit";
import { getItemModelsApi, saveModelManageApi, deleteItemModelApi } from "../../apiservice/inventory";

export const fetchModelsList = createAsyncThunk(
  "models/fetchModelsList",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getItemModelsApi(null);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const createOrUpdateModel = createAsyncThunk(
  "models/createOrUpdateModel",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await saveModelManageApi(payload);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const deleteModel = createAsyncThunk(
  "models/deleteModel",
  async (model_id, { rejectWithValue }) => {
    try {
      const res = await deleteItemModelApi({ model_id });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
